
const initialState = {
  trackings: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_TRACKING': {
      const { trackings } = payload;
      return {
        ...state,
        trackings,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Tracking/Tracking.reducer.js